<template>
  <b-row>
    <b-col cols="12">
      <b-row>
        <b-col>
          <div style="display:flex;justify-content: center;">
            <h4
              style=" display:flex;"
            >
              Propostas em tramitações
              <div style="padding-left: 0.4rem">
                <i
                  v-b-tooltip.hover
                  title="Propostas em tramitação da coluna Em negociação, com pendência de ação por parte do Cliente (Aguardando) ou da equipe interna (Não aprovada)."
                  style="font-size: 0.85rem;"
                  class="question-icon"
                >
                  <font-awesome-icon
                    :icon="faQuestionCircle"
                  />
                </i>
              </div>
            </h4></div>
        </b-col>
      </b-row>
      <b-row
        align-h="between"
        style="flex-direction: column;
        margin-left: 0px;"
      >
        <div
          style="    display: flex;
                     align-items: center;"
        >
          <div
            :style="`background-color: #0079BF`"
            :class="['square', {'opcao-branca': '#0079BF' === '#FFFFFF'}]"
          />
          <div>Aguardando</div>
        </div>

        <div
          style="    display: flex;
                    align-items: center;"
        >
          <div
            :style="`background-color: #EB5A46`"
            :class="['square', {'opcao-branca': '#7BC86C' === '#FFFFFF'}]"
          />
          <div>
            Não aprovada
          </div>
        </div>
        <div>
          &nbsp;
        </div>

      </b-row>
      <b-row
        align-h="center"
      >
        <donut-chart-comercial
          :id="$index"
          :dados="totalProposta"
          :total="totalProposta.totalPropostaStatus"
          :height="290"
        />
      </b-row>
      <b-col
        cols="auto"
        style="display: flex;align-items: center; border-top: 0.80px solid #82868b;justify-content:space-evenly;"
      >
        <div>
          <div
            style="display:flex;
             justify-content:center;
             align-items: center;"
          >
            <div
              :style="`background-color: #0079BF`"
              :class="['square', {'opcao-branca': '#0079BF' === '#FFFFFF'}]"
            />
            <div
              style="text-align: center;
            font-size: 16px;"
            >
              <b>

                Ação com Cliente
              </b>
            </div>
          </div>
          <div class="textogrande">
            <b>{{ totalProposta.quantidade[1] }}</b>
          </div>
        </div>

        <div style="border-left: 0.80px solid #82868b; height: 50px;">
        &nbsp;
        </div>

        <div>
          <div
            style="display:flex;
              justify-content:center;
              align-items: center;"
          >
            <div
              :style="`background-color: #EB5A46`"
              :class="['square', {'opcao-branca': '#7BC86C' === '#FFFFFF'}]"
            />
            <div
              style="align-self: center;
              font-size: 16px;"
            >
              <b>
                Ação Interna
              </b>
            </div>
          </div>
          <div class="textogrande">
            <b>{{ totalProposta.quantidade[0] }}</b>
          </div>
        </div>
      </b-col>
    </b-col>
  </b-row>
</template>

<style lang="scss">

.textogrande{
  margin-left: 65px;
  font-weight: bold;
  font-size: 22px;
}
.square {
  height: 10px;
  width: 10px;
  margin-right: 0.5rem;

}

.opcao-branca{
  border: 1px solid #82868b !important;
}
</style>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faQuestionCircle,
} from '@fortawesome/free-solid-svg-icons'
import api from '@/app-modulo/comercial/dashboard-comercial/shared/services/api'

export default {
  name: 'DetalhamentoComercial',
  components: {
    FontAwesomeIcon,
    DonutChartComercial: () => import('@/shared/components/donutchart-comercial/DonutChartComercial.vue'),
  },
  data() {
    return {
      faQuestionCircle,
      carregado: false,
      totalProposta: [],
      checklistTotal: null,
    }
  },
  created() {
    this.carregaDados()
  },
  methods: {
    carregaDados() {
      api.getDetalhamentoProposta()
        .then(payload => {
          this.totalProposta = payload.data
          this.propostaTotal = payload.datas.totalDePropostas
          this.carregado = true
        })
    },
  },
}
</script>
